import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import ReactNotifications from 'react-notifications-component';

import './app.scss';

import Loader from '../Loader';
import Home from '../Home';
import Login from '../Login';
import Admin from '../Admin';
import Footer from '../Footer';
import { graphqlRequest } from '../../utils/graphqlClient';
import { useAppContext } from '../../context/AppContext';

const App = () => {
  const { state, actions } = useAppContext();

  useEffect(() => {
    const restoreSession = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        return;
      }

      try {
        const response = await graphqlRequest(
          `
            query Me {
              me {
                username
              }
            }
          `,
          {},
          token
        );

        const username = response?.data?.data?.me?.username;
        if (username) {
          localStorage.setItem('username', username);
          actions.restoreAdmin(username);
          return;
        }
      } catch (_error) {
        // Ignore and clear invalid session below.
      }

      localStorage.removeItem('token');
      localStorage.removeItem('username');
    };

    restoreSession();
    actions.initData();
  }, [])

  return (
    <div id="app">
      <ReactNotifications />
      <Loader loading={state.loading} />
      <Switch>
        <Route path="/login">
          {state.isAdmin ? <Admin /> : <Login />}
        </Route>
        <Route exact path="/" component={Home} />
      </Switch>
      <Footer />
    </div>
  );
}

export default App;
